import React from 'react'

export default ({ onClickBack, onClickContinue }) => (
  <div className="page__popup">
    <div className="page__popup-col1">
      <p className="page__popup__cancel search-change__cancel">
        <a href="#" onClick={onClickBack}>
          <span className="page__popup__cancel-icon search-change__cancel-icon">
            ×
          </span>
        </a>
      </p>
      <div className="popup-headline">
        <h2 className="popup-headline__title">審査申請しました</h2>
        <p className="popup-headline__text">
          審査には2〜3営業日かかります。
          <br />
          審査のため、Paid（株式会社ラクーンフィナンシャル）より担当者様へお電話いたしますのでご了承ください。
        </p>
      </div>
      <div className="confirm-modal__button">
        <input
          type="button"
          name="commit"
          value="法人アカウントの登録に戻る"
          className="button-green mr5 pt15 pb15 w400 sm-w100"
          onClick={onClickContinue}
        />
      </div>
    </div>
  </div>
)
